
<template>
  <div id="treehistory">
    <!-- 表 -->
    <div class="history_meter_box">
      <!-- 树状图 -->
      <div class="Dendrogram_l">
        <div class="flowwidth" style="height: 100%;">
          <div class="Dendrogram_l_top">
            {{ name }}
            <span v-show="iconone" class="el-icon-close" @click="shanchuclick"></span>
            <span v-show="iconss" class="el-icon-plus" @click="jiaclick"></span>
            <!-- <span class="el-icon-d-arrow-left"></span> -->
          </div>
          <el-tree
            :data="datas"
            :datashuju="data"
            :props="defaultProps"
            highlight-current
            accordion
            @keydown.enter.native="handleNodeClick($event)"
            @node-click="handleNodeClick"
            node-key="id"
            icon-class="iconfont icon-file-close"
            :default-expanded-keys="[0]"
          ></el-tree>
          <!-- icon-class="el-icon-folder-opened" -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import local from "../../utils/local";
// import session from "../../utils/session";
export default {
  name: "treehistory",
  data() {
    return {
      data: this.datas,
      icon: this.iconone,
      icons: this.iconss,
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  props: {
    mrdk: Array,
    iconone: Boolean,
    iconss: Boolean,
    datas: Array,
    datashuju: {
      type: Array
    },
    name: {
      type: String,
      default: "分类信息"
    }
  },
  methods: {
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    // tree树
    clicknede() {
      // this.$store.commit("treedatashanchu", element);

      this.$emit("clicknede");
    },
    handleNodeClick(data, node, text) {
      console.log(data);

      this.$emit("handleNodeClick", data);
    },
    jiaclick() {
      this.$emit("jiaclick");
    },
    shanchuclick() {
      this.$emit("shanchuclick");
    }
  },
  created() {
    this.clicknede();
  }
};
</script>
<style lang="less">
.el-tree-node__expand-icon {
  font-size: 28px;
  margin-left: 12px;
}
.el-tree-node__expand-icon.expanded {
  -webkit-transform: rotate(0deg) !important;
  transform: rotate(0deg) !important;
}
.el-tree-node__content > .el-tree-node__expand-icon {
  padding: 0;
}

#treehistory {
  // 表
  .history_meter_box {
    width: 100%;
    .el-col-3 {
      margin-right: 28px;
    }

    // 树状图
    .Dendrogram_l {
      width: 100%;
      height: 332px;
      overflow: hidden;
      border: 1px solid #ccc;
      // padding-bottom: 5px;
      .el-tree {
        width: 108%;
        height: 95%;
        overflow: scroll;
      }
      .Dendrogram_l_top {
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 12px;
        text-indent: 6px;
        background-color: #f1f1f1;
        position: relative;

        span {
          display: inline-block;
          width: 30px;
          height: 30px;
          cursor: pointer;
          text-align: center;
          line-height: 30px;
          text-indent: 0;
          border-radius: 5px;
          //   margin: 0 1px;
        }
        span:nth-child(1) {
          position: absolute;
          top: 12%;
          right: 45%;
        }
        span:nth-child(2) {
          position: absolute;
          top: 12%;
          right: 26%;
        }
        span:nth-child(3) {
          position: absolute;
          top: 12%;
          right: 5%;
        }

        span:hover {
          background-color: #fff;
        }
      }

      .el-table--border {
        width: 96% !important;
        margin-left: 20px;
      }
    }

    // 表格
    .meter {
      width: 100%;
      height: 452px;
      position: relative;
      overflow: hidden;
      text-align: center;

      .iconset {
        position: absolute;
        top: 15px;
        left: 25px;
        z-index: 100;

        img {
          width: 29px;
          height: 28px;
        }
      }

      .el-table__body-wrapper {
        width: 10%;
        height: 470px;
        overflow-y: scroll;
      }

      .iconbox {
        z-index: 100;
      }
    }
  }
  .el-tree-node__expand-icon {
    font-size: 20px;
  }
  .el-tree-node__expand-icon.expanded {
    -webkit-transform: rotate(0deg) !important;
    transform: rotate(0deg) !important;
  }
  .el-tree-node__expand-icon.expanded::before {
    content: "\e62e";
    font-size: 22px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Common/treehistory/treehistory.vue